export enum ReferenceModelNameEnums {
    CITY = "CITY",
    AREA = "AREA",
    LOCALITY = "LOCALITY",
}
